import API from "@/api/lib/api";

export const getAllAllergens = async (restaurant_id, menu_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/allergens/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleAllergenById = async (id) => {
  try {
    const response = await API.get(`restaurant/allergens/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createAllergen = async (data) => {
  try {
    const response = await API.post(`restaurant/allergens`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateAllergen = async (id, data) => {
  try {
    const response = await API.put(`restaurant/allergens/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteAllergen = async (id) => {
  try {
    const response = await API.delete(`restaurant/allergens/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};